<div class="card-header">
  <div class="row align-items-center">
    <div class="col-auto">
      <div class="icon-rounded small-icon bg-secondary text-white">
        <i class="{{ iconClass }}"></i>
      </div>
    </div>
    <div class="col-auto card-title mb-0">
      {{ title }}
      @if (showStatus) {
        <i
          class="align-middle {{ statusIcon }} text-{{ statusColor }}"
          title="{{ statusTitle }}"></i>
      }
    </div>
    <div class="col-auto ms-auto">
      @if (showCollapse) {
        <div class="collapse-arrow">
          <div class="btn-action">
            <i class="iconoir-nav-arrow-right"></i>
          </div>
        </div>
      }
    </div>
  </div>
</div>
